import { getMediaDown } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  ${getMediaDown('md')} {
    margin: 10px 0 15px 0;
  }
`;

export const buttonContainerStyle = css`
  display: inline-block;
  position: relative;
  > button {
    padding: 0.5rem;
  }

  ${getMediaDown('md')} {
    > button {
      font-size: 0.875rem;
      height: 1.875rem;
    }
  }
`;
